import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { ReactComponent as DedicatedWarehouseSVG } from "../../../../../assets/icons/warehouse-dedicated.svg";
import { ReactComponent as MultiWarehouseSVG } from "../../../../../assets/icons/multi-warehouse.svg";
import Icon from "../../../../../components/icon";




export const TypesOfOffers = () => {
    return (
        <>
            {/* <Title>Rodzaje oferty</Title> */}
            <ItemWraper  >
                <ItemNumber>
                    <Icon
                        width="29px"
                        height="32px"
                        noPadding
                        icon={<DedicatedWarehouseSVG />} />
                </ItemNumber>
                <ItemDescription>
                    <TitleDesctiption>
                        Magazyn dedykowany
                    </TitleDesctiption>
                    <ContinuationDescription>
                        Twój towar zostanie umieszczony w jednym magazynie.
                    </ContinuationDescription>
                </ItemDescription>
            </ItemWraper>
            <ItemWraper  >
                <ItemNumber>
                    <Icon
                        width="29px"
                        height="32px"
                        noPadding
                        icon={<MultiWarehouseSVG />} />
                </ItemNumber>
                <ItemDescription>
                    <TitleDesctiption>
                        Multi magazyn
                    </TitleDesctiption>
                    <ContinuationDescription>
                        Jeśli twój <strong>towar nie zmieści się</strong> w jednym magazynie, zaproponujemy Ci jego <strong>składowanie w kilku miejscach,</strong> znajdujących się blisko siebie.
                    </ContinuationDescription>
                </ItemDescription>
            </ItemWraper>


        </>
    );
};

const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
padding-bottom:23px;
`;
const ItemWraper = styled.div`
display:flex;
flex-direction:row;
justify-content: flex-start;
padding-bottom:16px;
`;
const ItemNumber = styled.div`
font-family: ${theme.fonts.interRegular}
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
text-align: center;
color: ${theme.colors.gray04_background};
`;
const ItemDescription = styled.div`
padding-left:12px;
`;
const TitleDesctiption = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-bottom:8px;
`;
const ContinuationDescription = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
& strong {
    color: ${theme.colors.black_primaryText};
}`;